// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"vv_a bhb_b"};